export default __webpack_public_path__ + "static/media/Book_duotone.be08ca9e.svg";